import { useContext } from 'react';
import DataTableContext from './DataTableContext';

const useDataTable = () => useContext(DataTableContext);

export default useDataTable;
